import React, { FC, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import useDimension from '../../../hooks/useDimension';
import usePublicForm from '../../../hooks/api/form/usePublicForm';
import Form from '../../../components/form/public/Form';
import LoadingSpinner from '../../../components/layout/loadingSpinner/LoadingSpinner';

const FormEmbedPage: FC = () => {
  const formRef = useRef<HTMLDivElement>(null);
  const { formId } = useParams<{ formId: string }>();
  const { height } = useDimension(formRef);
  const { form, organization, setFormId, isLoading } = usePublicForm();

  useEffect(() => {
    if (formId) {
      setFormId(formId);
    }
  }, [formId]);

  useEffect(() => {
    parent.postMessage({ id: formId, height: height }, '*');
  }, [height]);
  return (
    <div ref={formRef}>
      <div className="app">
        <div className="app-container">
          {isLoading && <LoadingSpinner />}
          {!isLoading && form && organization && (
            <Form form={form} organization={organization} showShareModal={false}></Form>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormEmbedPage;
